import React from "react";

import Cookies from "js-cookie";
import { Navigate } from "react-router-dom";

export const RequireAuth: React.FC = ({ children }) => {
  const token = Cookies.get("token");
  return token ? <>{children}</> : <Navigate to="/login" replace />;
};

export const RequireNoAuth: React.FC = ({ children }) => {
  const token = Cookies.get("token");
  return token ? <Navigate to="/" replace /> : <>{children}</>;
};
